import createSvgIcon from "./utils/create_icon"

const ArrowDown = createSvgIcon(<path d="M9.707 13.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L13 14.586V7a1 1 0 1 0-2 0v7.586z" fill="currentColor" />, "ArrowDown")
export default ArrowDown
